import React from 'react';

/**
 * YouTubeEmbed
 * Responsive YouTube video embed component.
 * Extracts video ID from various YouTube URL formats.
 */
export default function YouTubeEmbed({ url, title = 'Speech Recording' }) {
  // Extract video ID from various YouTube URL formats
  const getVideoId = (youtubeUrl) => {
    if (!youtubeUrl) return null;

    // Handle youtu.be short URLs
    const shortMatch = youtubeUrl.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (shortMatch) return shortMatch[1];

    // Handle youtube.com watch URLs
    const watchMatch = youtubeUrl.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch) return watchMatch[1];

    // Handle youtube.com embed URLs
    const embedMatch = youtubeUrl.match(/embed\/([a-zA-Z0-9_-]{11})/);
    if (embedMatch) return embedMatch[1];

    return null;
  };

  const videoId = getVideoId(url);

  if (!videoId) {
    return (
      <div className="aspect-video rounded-xl flex items-center justify-center" style={{ background: 'var(--bg-input)' }}>
        <div className="text-center" style={{ color: 'var(--text-faint)' }}>
          <p className="text-4xl mb-2">📺</p>
          <p className="text-sm">Video not available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="aspect-video rounded-xl overflow-hidden bg-black">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
      />
    </div>
  );
}
